export default "__VITE_ASSET__DM$AGIcK__"